import { http } from '@/http/axios';
import type {
  WebinarAiGenerationInput,
  WebinarAiGenerationResponse,
  WebinarAiGenerationStatusResult,
  WebinarAiSlidesUploadUrlInput,
  WebinarAiSlidesUploadUrlResult,
} from '@/features/webinarAiGeneration/types';

// Le job externe (Go) peut prendre du temps à générer le JSON complet du webinaire :
// on relève le timeout axios au-dessus de l'attente serveur habituelle.
const GENERATION_STATUS_REQUEST_TIMEOUT_MS = 35000;

export const webinarAiGenerationService = {
  generateSlidesUploadUrl: (
    workspaceId: number,
    input: WebinarAiSlidesUploadUrlInput,
  ): Promise<WebinarAiSlidesUploadUrlResult> =>
    http
      .post<WebinarAiSlidesUploadUrlResult>(
        `/workspaces/${workspaceId}/webinar-ai-generations/slides/upload-url`,
        input,
      )
      .then((r) => r.data),
  uploadSlidesFile: async (uploadUrl: string, file: File): Promise<void> => {
    const response = await fetch(uploadUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': file.type,
        'Cache-Control': 'public, max-age=31536000, immutable',
      },
      body: file,
    });
    if (!response.ok) {
      throw new Error(`Failed to upload slides file: ${response.statusText}`);
    }
  },
  markResourceReady: (workspaceId: number, resourceId: number): Promise<void> =>
    http.put(`/workspaces/${workspaceId}/resources/${resourceId}/status`).then(() => undefined),
  createGeneration: (
    workspaceId: number,
    input: WebinarAiGenerationInput,
  ): Promise<WebinarAiGenerationResponse> =>
    http
      .post<WebinarAiGenerationResponse>(`/workspaces/${workspaceId}/webinar-ai-generations`, input)
      .then((r) => r.data),
  getGenerationStatus: (
    workspaceId: number,
    generationId: number,
  ): Promise<WebinarAiGenerationStatusResult> =>
    http
      .get<WebinarAiGenerationStatusResult>(
        `/workspaces/${workspaceId}/webinar-ai-generations/${generationId}`,
        { timeout: GENERATION_STATUS_REQUEST_TIMEOUT_MS },
      )
      .then((r) => r.data),
};
